import moment from "moment-timezone";
import {
  SINGLE_DAY_DATE_FORMAT,
  MonthlyViewDay,
  MonthlyViewWeek,
} from "../monthly-view.types";

const getMonthlyViewWeeks = (timeRange: number[], timezone: string) => {
  const weeksInMonth: MonthlyViewWeek[] = [];
  const weekIndexDictionary: {
    [date: string]: { weekIndex: number; dayIndex: number };
  } = {};

  for (let weekIndex = 0; weekIndex < 5; weekIndex++) {
    const currentWeek: MonthlyViewWeek = [];
    for (let dayIndex = 0; dayIndex < 7; dayIndex++) {
      const start = moment
        .tz(timeRange[0], timezone)
        .add(weekIndex, "week")
        .add(dayIndex, "day");

      const end = start.clone().add(1, "day");
      const dateId = start.format(SINGLE_DAY_DATE_FORMAT);

      const day: MonthlyViewDay = {
        startISO: start.toISOString(),
        endISO: end.toISOString(),
        slots: [],
      };

      currentWeek.push(day);
      weekIndexDictionary[dateId] = { weekIndex, dayIndex };
    }
    weeksInMonth.push(currentWeek);
  }
  return { weeksInMonth, weekIndexDictionary };
};

export default getMonthlyViewWeeks;
